import {
    snakeCase,
    text,
    varchar,
    integer,
    numeric,
    index,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitsTable } from './benefits.table'

export const benefitTiersTable = snakeCase.table(
    'benefit_tiers',
    {
        id: id('btier'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        tierName: varchar({ length: 100 }),

        // Thresholds (Volume Spending in Cents)
        minPurchaseCents: integer().notNull().default(0),
        maxPurchaseCents: integer(),

        // Discount Configuration
        discountType: varchar({ length: 50 })
            .$type<'percentage' | 'flat' | 'cashback'>()
            .notNull(),
        flatAmountCents: integer(),
        percentageValue: numeric({ precision: 5, scale: 2 }),
        maxDiscountCents: integer(),

        // User Level / Tier Segmentation
        targetUserLevel: varchar({ length: 50 }).default('all'), // 'all' | 'standard' | 'vip' | 'executive'
        priority: integer().default(0),

        ...timestamps,
    },
    (table) => [
        index('benefit_tiers_benefit_idx').on(table.benefitId),
        index('benefit_tiers_eval_idx').on(
            table.benefitId,
            table.targetUserLevel,
            table.minPurchaseCents,
        ),
    ],
)
